import type { SessionRuntimeState } from "@herskin/contracts";

/** 统一使用英文 k/m 紧凑单位，避免浏览器区域设置把 31.5k 渲染成“3.2万”。 */
export function formatCompactTokens(value: number) {
  if (value >= 1_000_000) {
    const scaled = value / 1_000_000;
    return `${scaled >= 10 || Number.isInteger(scaled) ? scaled.toFixed(0) : scaled.toFixed(1)}m`;
  }
  if (value >= 1_000) {
    const scaled = value / 1_000;
    return `${scaled >= 100 || Number.isInteger(scaled) ? scaled.toFixed(0) : scaled.toFixed(1)}k`;
  }
  return String(value);
}

export function compactContextLabel(state: SessionRuntimeState | null, loading: boolean) {
  if (loading) return "正在读取";
  if (!state) return "暂不可用";
  if (state.availability === "not_started") return "首次发送后生成";
  if (state.availability === "adapter_unavailable") return "Hermes 未连接";
  const usage = state.usage;
  if (
    !usage ||
    usage.occupancyMeasurement !== "live_window" ||
    usage.contextUsed === null ||
    usage.contextMax === null ||
    usage.contextPercent === null
  ) {
    return "当前窗口暂不可用";
  }
  return `${formatCompactTokens(usage.contextUsed)} / ${formatCompactTokens(usage.contextMax)} · ${Math.round(usage.contextPercent)}%`;
}

export function runtimeAvailabilityCopy(state: SessionRuntimeState | null, loading: boolean) {
  if (loading) return "正在从 Hermes 读取当前 Session 的真实用量。";
  if (!state || state.availability === "unavailable") {
    return "Hermes 暂未返回可验证的运行时用量。";
  }
  if (state.availability === "not_started") {
    return "该草稿尚未在 Hermes 创建 Session，首次发送后才会产生上下文。";
  }
  if (state.availability === "adapter_unavailable") {
    return "HerSkin 与 Hermes 恢复连接后会重新读取，不使用本地估算值。";
  }
  if (state.availability === "stored_only") {
    return "累计 Token 来自 Hermes 持久会话；当前窗口占用要等运行时重新测量。";
  }
  if (state.usage?.occupancyMeasurement === "unknown") {
    return "累计 Token 可用，但 Hermes 尚未提供这一轮的真实当前窗口占用。";
  }
  return "当前窗口取自 Hermes 最近一次 Provider 请求；累计 Token 取自持久 Session。";
}
